import { render } from "./ViewAsset.vue?vue&type=template&id=0910978d&scoped=true"
import script from "./ViewAsset.vue?vue&type=script&lang=js"
export * from "./ViewAsset.vue?vue&type=script&lang=js"

import "./ViewAsset.vue?vue&type=style&index=0&id=0910978d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0910978d"]])

export default __exports__